// Configuración centralizada de la URL del backend
// En producción, usa REACT_APP_API_URL si está definida, 
// o el dominio personalizado por defecto
const getApiUrl = () => {
  // Si hay una variable de entorno, úsala (útil para Railway u otros servicios)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // En desarrollo, usar localhost
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3001";
  }
  
  // En producción, usar el dominio personalizado
  // Si el backend está en el mismo dominio, usar la ruta relativa o el mismo dominio
  // Si está en un subdominio, ajustar según corresponda
  return "https://www.deitanaia.com";
};

export const API_URL = getApiUrl();

